export default __webpack_public_path__ + "static/media/crossfire.22cac39c.png";